import type { Editor } from '@tiptap/core';

/**
 * True when the TipTap editor exists, is not destroyed, and its ProseMirror root
 * is attached to the document. Use before DOM mapping or view-dependent work.
 */
export function isEditorDomConnected(editor: Editor | null | undefined): boolean {
  return Boolean(editor && !editor.isDestroyed && editor.view?.dom?.isConnected);
}
